<template>
    <eSesjaModal size="large" class="client-invoice-modal">
        <eSesjaModalHeader @close="closeModal">
            {{ $t('com.file.client-invoice-data-settings.edit-title') }}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <p class="py-2">{{ $t('com.file.client-invoice-data-settings.invoice-description') }}</p>
            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.invoice-email') }}</label>
            <section class="esesja-modal__row">
                <input class="esesja-modal__wraper__body__input"
                    :class="{ 'input-has-error': isTooLong(model.invoiceEmail, maxLengths.invoiceEmail) || isInvoiceEmailInvalid }" type="email"
                    :maxlength="maxLengths.invoiceEmail" v-model="model.invoiceEmail" />
            </section>
            <ErrorMessage v-if="isInvoiceEmailInvalid" :errorMsgs="[$t('com.validation-error.invalid-email-format')]" />
            <CharactersCounter :text="model.invoiceEmail" :maxLenght="maxLengths.invoiceEmail" />
            <section class="d-flex flex-row py-3">
                <section class="buyer-section" style="padding-right: 1vw; border-right: 1px solid #dde0e7;">
                    <h5 class="client-invoice-data__group__title">{{ $t('com.file.client-invoice-data-settings.buyer')
                        }}
                    </h5>
                    <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.buyer-group') }}</label>
                    <section class="esesja-modal__row pb-3">
                        <Multiselect v-model="selectedBuyerGroup" :options="buyerGroupOptions" :searchable="true"
                            :close-on-select="true" :create-option="false" :object="true" :can-clear="false"
                            :noResultsText="$t('com.global.no-results')" :noOptionsText="$t('com.global.no-options')" />
                    </section>
                    <section class="d-flex flex-row gap-1 flex-fill">
                        <section class="d-flex flex-column w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.country-id') }}</label>
                            <section class="esesja-modal__row">
                                <Multiselect v-model="selectedCountry" :options="countriesOptions" :searchable="true"
                                    :close-on-select="true" :create-option="false" :object="true" :can-clear="false"
                                    :noResultsText="$t('com.global.no-results')"
                                    :noOptionsText="$t('com.global.no-options')" />
                            </section>
                        </section>
                        <section class="d-flex flex-column w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.tax-id') }}</label>
                            <section class="esesja-modal__row">
                                <section class="d-flex flex-row">
                                    <input class="esesja-modal__wraper__body__input"
                                        :class="{ 'input-has-error': isTooLong(model.buyer.taxId, maxLengths.buyerTaxId) || isRequiredMissing(model.buyer.taxId) || (isValidNipDigitsOnly(model.buyer.taxId) === false && selectedCountry != null && selectedCountry.symbol === 'PL') }"
                                        type="text" inputmode="numeric" :maxlength="maxLengths.buyerTaxId"
                                        v-model="model.buyer.taxId" />
                                    <section class="button-show" @click="fetchGusData(model.buyer.taxId, 'buyer')"
                                        v-if="selectedCountry != null && selectedCountry.symbol === 'PL'"
                                        v-tooltip="$t('com.file.client-invoice-data-settings.fetch-gus-data')">
                                        <img src="~@/assets/icons/panel/Contacts/search.svg" />
                                    </section>
                                </section>
                                <CharactersCounter :text="model.buyer.taxId" :maxLenght="maxLengths.buyerTaxId" />
                            </section>
                        </section>
                    </section>
                    <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.name')
                        }}</label>
                    <section class="esesja-modal__row">
                        <input class="esesja-modal__wraper__body__input"
                            :class="{ 'input-has-error': isTooLong(model.buyer.name, maxLengths.buyerName) || isRequiredMissing(model.buyer.name) }"
                            :maxlength="maxLengths.buyerName" v-model="model.buyer.name" />
                        <CharactersCounter :text="model.buyer.name" :maxLenght="maxLengths.buyerName" />
                    </section>

                    <section class="d-flex flex-row gap-1 flex-fill">
                        <section class="d-flex flex-column w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.city') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.buyer.city, maxLengths.buyerCity) }"
                                    :maxlength="maxLengths.buyerCity" v-model="model.buyer.city" />
                                <CharactersCounter :text="model.buyer.city" :maxLenght="maxLengths.buyerCity" />
                            </section>
                        </section>
                        <section class="d-flex flex-column flex-fill">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.address') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.buyer.address, maxLengths.buyerAddress) }"
                                    :maxlength="maxLengths.buyerAddress" v-model="model.buyer.address" />
                                <CharactersCounter :text="model.buyer.address" :maxLenght="maxLengths.buyerAddress" />
                            </section>
                        </section>
                    </section>

                    <section class="d-flex flex-row gap-1 flex-fill">
                        <section class="d-flex flex-column w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.buyer.postalCode, maxLengths.buyerPostalCode) }"
                                    :maxlength="maxLengths.buyerPostalCode" v-model="model.buyer.postalCode" />
                                <CharactersCounter :text="model.buyer.postalCode"
                                    :maxLenght="maxLengths.buyerPostalCode" />
                            </section>
                        </section>
                        <section class="d-flex flex-column w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.post-office') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.buyer.postOffice, maxLengths.buyerPostOffice) }"
                                    :maxlength="maxLengths.buyerPostOffice" v-model="model.buyer.postOffice" />
                                <CharactersCounter :text="model.buyer.postOffice"
                                    :maxLenght="maxLengths.buyerPostOffice" />
                            </section>
                        </section>
                    </section>
                    <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.gln') }}</label>
                    <section class="esesja-modal__row">
                        <input class="esesja-modal__wraper__body__input"
                            :class="{ 'input-has-error': isTooLong(model.buyer.gln, maxLengths.buyerGln) }"
                            :maxlength="maxLengths.buyerGln" v-model="model.buyer.gln" />
                        <CharactersCounter :text="model.buyer.gln" :maxLenght="maxLengths.buyerGln" />
                    </section>
                </section>
                <section class="recipent-section" style="padding-left: 1vw;">
                    <h5 class="client-invoice-data__group__title">{{
            $t('com.file.client-invoice-data-settings.recipient')
        }}
                    </h5>
                    <label class="esesja-modal__wraper__body__label">{{
                $t('com.file.client-invoice-data-settings.recipient-role') }}</label>
                    <section class="esesja-modal__row pb-3">
                        <Multiselect v-model="selectedRecipientRole" :options="recipientRoleOptions" :searchable="true"
                            :close-on-select="true" :create-option="false" :object="true"
                            :disabled="isRecipientRoleLocked" :can-clear="false"
                            :noResultsText="$t('com.global.no-results')" :noOptionsText="$t('com.global.no-options')" />
                    </section>
                    <section class="d-flex flex-row gap-1 flex-fill">
                        <section class="d-flex flex-column  w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.country-id') }}</label>
                            <section class="esesja-modal__row">
                                <Multiselect v-model="selectedRecipientCountry" :options="countriesOptions"
                                    :searchable="true" :close-on-select="true" :create-option="false" :object="true"
                                    :can-clear="false" :noResultsText="$t('com.global.no-results')"
                                    :noOptionsText="$t('com.global.no-options')" />
                            </section>
                        </section>
                        <section class="d-flex flex-column  w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.tax-id') }}</label>
                            <section class="esesja-modal__row">
                                <section class="d-flex flex-row">
                                    <input class="esesja-modal__wraper__body__input"
                                        :class="{ 'input-has-error': isTooLong(model.recipient.taxId, maxLengths.recipientTaxId) || (model.recipient.taxId && isValidNipDigitsOnly(model.recipient.taxId) === false && selectedRecipientCountry != null && selectedRecipientCountry.symbol === 'PL') || (isRecipientRequired && isRequiredMissing(model.recipient.taxId)) }"
                                        type="text" inputmode="numeric" :maxlength="maxLengths.recipientTaxId"
                                        :disabled="!!model.recipientInternalIdentifier"
                                        v-model="model.recipient.taxId" />
                                    <section class="button-show"
                                        @click="fetchGusData(model.recipient.taxId, 'recipient')"
                                        v-if="selectedRecipientCountry != null && selectedRecipientCountry.symbol === 'PL'"
                                        v-tooltip="$t('com.file.client-invoice-data-settings.fetch-gus-data')">
                                        <img src="~@/assets/icons/panel/Contacts/search.svg" />
                                    </section>
                                </section>
                                <CharactersCounter :text="model.recipient.taxId"
                                    :maxLenght="maxLengths.recipientTaxId" />
                            </section>
                        </section>
                    </section>
                    <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.recipient-internal-identifier') }}</label>
                    <section class="esesja-modal__row">
                        <input class="esesja-modal__wraper__body__input"
                            :class="{ 'input-has-error': isTooLong(model.recipientInternalIdentifier, maxLengths.recipientInternalIdentifier) }"
                            :maxlength="maxLengths.recipientInternalIdentifier" :disabled="!!model.recipient.taxId"
                            v-model="model.recipientInternalIdentifier" />
                        <CharactersCounter :text="model.recipientInternalIdentifier"
                            :maxLenght="maxLengths.recipientInternalIdentifier" />
                    </section>
                    <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.name') }}</label>
                    <section class="esesja-modal__row">
                        <input class="esesja-modal__wraper__body__input"
                            :class="{ 'input-has-error': isTooLong(model.recipient.name, maxLengths.recipientName) || (isRecipientRequired && isRequiredMissing(model.recipient.name)) }"
                            :maxlength="maxLengths.recipientName" v-model="model.recipient.name" />
                        <CharactersCounter :text="model.recipient.name" :maxLenght="maxLengths.recipientName" />
                    </section>

                    <section class="d-flex flex-row gap-1 flex-fill">
                        <section class="d-flex flex-column  w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.city') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.recipient.city, maxLengths.recipientCity) }"
                                    :maxlength="maxLengths.recipientCity" v-model="model.recipient.city" />
                                <CharactersCounter :text="model.recipient.city" :maxLenght="maxLengths.recipientCity" />
                            </section>
                        </section>
                        <section class="d-flex flex-column  w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.address') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.recipient.address, maxLengths.recipientAddress) }"
                                    :maxlength="maxLengths.recipientAddress" v-model="model.recipient.address" />
                                <CharactersCounter :text="model.recipient.address"
                                    :maxLenght="maxLengths.recipientAddress" />
                            </section>

                        </section>
                    </section>

                    <section class="d-flex flex-row gap-1 flex-fill">
                        <section class="d-flex flex-column  w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.recipient.postalCode, maxLengths.recipientPostalCode) }"
                                    :maxlength="maxLengths.recipientPostalCode" v-model="model.recipient.postalCode" />
                                <CharactersCounter :text="model.recipient.postalCode"
                                    :maxLenght="maxLengths.recipientPostalCode" />
                            </section>

                        </section>
                        <section class="d-flex flex-column  w-50">
                            <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.post-office') }}</label>
                            <section class="esesja-modal__row">
                                <input class="esesja-modal__wraper__body__input"
                                    :class="{ 'input-has-error': isTooLong(model.recipient.postOffice, maxLengths.recipientPostOffice) }"
                                    :maxlength="maxLengths.recipientPostOffice" v-model="model.recipient.postOffice" />
                                <CharactersCounter :text="model.recipient.postOffice"
                                    :maxLenght="maxLengths.recipientPostOffice" />
                            </section>

                        </section>
                    </section>
                    <label class="esesja-modal__wraper__body__label">{{
            $t('com.file.client-invoice-data-settings.gln') }}</label>
                    <section class="esesja-modal__row">
                        <input class="esesja-modal__wraper__body__input"
                            :class="{ 'input-has-error': isTooLong(model.recipient.gln, maxLengths.recipientGln) }"
                            :maxlength="maxLengths.recipientGln" v-model="model.recipient.gln" />
                        <CharactersCounter :text="model.recipient.gln" :maxLenght="maxLengths.recipientGln" />
                    </section>
                </section>
            </section>
            <section class="edit-point-form__checkbox-top">
                <section class="edit-point-form__checkbox-wrapper">
                    <input type="checkbox" class="edit-point-form__checkbox" v-model="userConfirmTaxData" />
                    <section class="edit-point-form__checkbox-mark">
                        <img src="~@/assets/icons/components/accept-mark.svg" />
                    </section>
                </section>
                <label class="
                                edit-point-form__label
                                edit-point-form__label--checkbox
                            " @click="userConfirmTaxData = !userConfirmTaxData">
                    {{$t('com.file.client-invoice-data-settings.confirm-tax-data')}}
                </label>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="closeModal">
                {{ $t('com.global.cancel') }}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @click="saveData" :disabled="isSaving || hasError || !userConfirmTaxData">
                {{ $t('com.global.save') }}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
import ClientInvoiceDataService from "@/services/client.invoice.data.service";
import CountryService from "@/services/country.service";
import UserService from "@/services/user.service";
import Multiselect from "@vueform/multiselect";
import CharactersCounter from "@/components/BasicControls/CharactersCounter.vue";
import ErrorMessage from "@/components/BasicControls/ErrorMessage.vue";
import { isValidNipDigitsOnly, validateEmail } from "@/helpers/utils";

const createEmptyContractor = () => ({
    name: "",
    address: "",
    postalCode: "",
    city: "",
    postOffice: "",
    taxId: "",
    gln: "",
    country: {
        id: 0,
        country: "",
        symbol: ""
    }
});

const createEmptyData = () => ({
    id: 0,
    buyer: createEmptyContractor(),
    recipient: createEmptyContractor(),
    buyerGroup: null,
    recipientRole: null,
    invoiceEmail: "",
    recipientInternalIdentifier: "",
    lastVerificationDate: null
});

export default {
    name: "ClientInvoiceBuyerModal",
    components: {
        Multiselect,
        CharactersCounter,
        ErrorMessage
    },
    data() {
        return {
            model: createEmptyData(),
            isSaving: false,
            selectedCountry: null,
            selectedRecipientCountry: null,
            selectedBuyerGroup: null,
            selectedRecipientRole: null,
            buyerGroups: [],
            recipientRoles: [],
            userConfirmTaxData: false,
            maxLengths: {
                invoiceEmail: 100,
                buyerName: 200,
                buyerAddress: 200,
                buyerPostalCode: 50,
                buyerCity: 100,
                buyerPostOffice: 100,
                buyerTaxId: 50,
                buyerGln: 20,
                recipientName: 200,
                recipientAddress: 200,
                recipientPostalCode: 50,
                recipientCity: 100,
                recipientPostOffice: 100,
                recipientTaxId: 50,
                recipientGln: 20,
                recipientInternalIdentifier: 50
            },
        };
    },
    async mounted() {
        try {
            this.$store.commit("showLoader");
            await this.loadCountries();
            await this.loadBuyerGroups();
            await this.loadRecipientRoles();
            await this.fetchInvoiceData();
        }
        finally {
            this.$store.commit("hideLoader");
        }
    },
    watch: {
        buyerGroupCode() {
            this.applyRecipientRoleFromBuyerGroup();
        },
        recipientRoleOptions() {
            this.applyRecipientRoleFromBuyerGroup();
        }
    },
    computed: {
        countriesOptions() {
            const countries = this.$store.state.countryStore.countries || [];
            return countries.map(item => ({
                label: item.country ? `${item.country}${item.symbol ? ` (${item.symbol})` : ""}` : (item.symbol || ""),
                value: item.id,
                country: item.country,
                symbol: item.symbol
            }));
        },
        buyerGroupOptions() {
            return (this.buyerGroups || []).map(item => ({
                value: item.id ?? item.Id,
                label: item.label ?? item.Label ?? item.code ?? item.Code ?? "",
                code: item.code ?? item.Code,
                description: item.description ?? item.Description,
                ksefValue: item.ksefValue ?? item.KsefValue
            }));
        },
        recipientRoleOptions() {
            const options = (this.recipientRoles || []).map(item => ({
                value: item.id ?? item.Id,
                label: item.label ?? item.Label ?? item.code ?? item.Code ?? "",
                code: item.code ?? item.Code,
                description: item.description ?? item.Description
            }));
            return [
                {
                    value: null,
                    label: this.$t("com.file.client-invoice-data-settings.no-role"),
                    code: null,
                    description: null
                },
                ...options
            ];
        },
        buyerGroupCode() {
            return (this.selectedBuyerGroup?.code || "").toUpperCase();
        },
        isRecipientRequired() {
            return this.buyerGroupCode === "JST" || this.buyerGroupCode === "GV";
        },
        isRecipientRoleLocked() {
            return this.isRecipientRequired;
        },
        isInvoiceEmailInvalid() {
            return !!this.model.invoiceEmail && validateEmail(this.model.invoiceEmail);
        },
        hasError() {
            return this.isRequiredMissing(this.model.buyer.name)
                || this.isRequiredMissing(this.model.buyer.taxId)
                || (this.isValidNipDigitsOnly(this.model.buyer.taxId) === false && this.selectedCountry != null && this.selectedCountry.symbol === 'PL')
                || this.isInvoiceEmailInvalid
                || this.isTooLong(this.model.invoiceEmail, this.maxLengths.invoiceEmail)
                || this.isTooLong(this.model.buyer.name, this.maxLengths.buyerName)
                || this.isTooLong(this.model.buyer.address, this.maxLengths.buyerAddress)
                || this.isTooLong(this.model.buyer.postalCode, this.maxLengths.buyerPostalCode)
                || this.isTooLong(this.model.buyer.city, this.maxLengths.buyerCity)
                || this.isTooLong(this.model.buyer.postOffice, this.maxLengths.buyerPostOffice)
                || this.isTooLong(this.model.buyer.taxId, this.maxLengths.buyerTaxId)
                || this.isTooLong(this.model.buyer.gln, this.maxLengths.buyerGln)
                || (this.model.recipient.taxId && this.isValidNipDigitsOnly(this.model.recipient.taxId) === false && this.selectedRecipientCountry != null && this.selectedRecipientCountry.symbol === 'PL')
                || this.isTooLong(this.model.recipient.name, this.maxLengths.recipientName)
                || this.isTooLong(this.model.recipient.address, this.maxLengths.recipientAddress)
                || this.isTooLong(this.model.recipient.postalCode, this.maxLengths.recipientPostalCode)
                || this.isTooLong(this.model.recipient.city, this.maxLengths.recipientCity)
                || this.isTooLong(this.model.recipient.postOffice, this.maxLengths.recipientPostOffice)
                || this.isTooLong(this.model.recipient.taxId, this.maxLengths.recipientTaxId)
                || this.isTooLong(this.model.recipient.gln, this.maxLengths.recipientGln)
                || this.isTooLong(this.model.recipientInternalIdentifier, this.maxLengths.recipientInternalIdentifier)
                || (this.isRecipientRequired && this.isRequiredMissing(this.model.recipient.name))
                || (this.isRecipientRequired && this.isRequiredMissing(this.model.recipient.taxId))
                || (this.isRecipientRoleLocked && !this.selectedRecipientRole)
                || ((!!this.model.recipient.taxId || !!this.model.recipientInternalIdentifier) && (!this.selectedRecipientRole || this.selectedRecipientRole.value == null));
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("setClientInvoiceBuyerModalStatus", false);
        },
        async loadCountries() {
            const countries = this.$store.state.countryStore.countries || [];
            if (countries.length > 0) {
                return;
            }
            await CountryService.getCountries();
        },
        async loadBuyerGroups() {
            const response = await ClientInvoiceDataService.getBuyerGroups();
            if (response.status !== 200) {
                throw await Promise.reject(response);
            }
            this.buyerGroups = response.data || [];
        },
        async loadRecipientRoles() {
            const response = await ClientInvoiceDataService.getRecipientRoles();
            if (response.status !== 200) {
                throw await Promise.reject(response);
            }
            this.recipientRoles = response.data || [];
        },
        async fetchInvoiceData() {
            const response = await ClientInvoiceDataService.getClientInvoiceData();
            if (response.status !== 200) {
                throw await Promise.reject(response);
            }
            this.model = response.data || createEmptyData();
            this.selectedCountry = this.getSelectedCountry(this.model.buyer?.country?.id);
            this.selectedRecipientCountry = this.getSelectedCountry(this.model.recipient?.country?.id);
            this.selectedBuyerGroup = this.getSelectedBuyerGroup(this.model.buyerGroup?.id);
            this.selectedRecipientRole = this.getSelectedRecipientRole(this.model.recipientRole?.id);
            this.applyRecipientRoleFromBuyerGroup();
        },
        getSelectedCountry(countryId) {
            if (!countryId) {
                return null;
            }
            return this.countriesOptions.find(item => item.value === countryId) || null;
        },
        getSelectedBuyerGroup(groupId) {
            if (!groupId) {
                return null;
            }
            return this.buyerGroupOptions.find(item => item.value === groupId) || null;
        },
        getSelectedRecipientRole(roleId) {
            if (!roleId) {
                return null;
            }
            return this.recipientRoleOptions.find(item => item.value === roleId) || null;
        },
        applyRecipientRoleFromBuyerGroup() {
            if (!this.isRecipientRoleLocked) {
                return;
            }

            const roles = this.recipientRoleOptions;
            let match = null;
            if (this.buyerGroupCode === "JST") {
                match = roles.find(item => (item.code || "").toUpperCase() === "JST")
                    || roles.find(item => (item.label || "").toLowerCase().includes("jst") && (item.label || "").toLowerCase().includes("odbiorca"));
            }
            if (this.buyerGroupCode === "GV") {
                match = roles.find(item => (item.code || "").toUpperCase() === "GV")
                    || roles.find(item => (item.label || "").toLowerCase().includes("gv") && (item.label || "").toLowerCase().includes("odbiorca"));
            }

            if (match) {
                this.selectedRecipientRole = match;
            }
        },
        async saveData() {
            if (this.hasError) {
                return;
            }
            if (!this.userConfirmTaxData) {
                return;
            }

            try {
                this.isSaving = true;
                this.$store.commit("showLoader");
                if (this.selectedCountry) {
                    this.model.buyer.country = {
                        id: this.selectedCountry.value,
                        country: this.selectedCountry.country,
                        symbol: this.selectedCountry.symbol
                    };
                }
                if (this.selectedRecipientCountry) {
                    this.model.recipient.country = {
                        id: this.selectedRecipientCountry.value,
                        country: this.selectedRecipientCountry.country,
                        symbol: this.selectedRecipientCountry.symbol
                    };
                }
                if (this.selectedBuyerGroup) {
                    this.model.buyerGroup = {
                        id: this.selectedBuyerGroup.value,
                        code: this.selectedBuyerGroup.code,
                        label: this.selectedBuyerGroup.label,
                        description: this.selectedBuyerGroup.description,
                        ksefValue: this.selectedBuyerGroup.ksefValue
                    };
                }
                if (this.selectedRecipientRole && this.selectedRecipientRole.value != null) {
                    this.model.recipientRole = {
                        id: this.selectedRecipientRole.value,
                        code: this.selectedRecipientRole.code,
                        label: this.selectedRecipientRole.label,
                        description: this.selectedRecipientRole.description
                    };
                } else {
                    this.model.recipientRole = null;
                }
                if (!this.model || !this.model.id) {
                    await ClientInvoiceDataService.createClientInvoiceData(this.model);
                } else {
                    await ClientInvoiceDataService.updateClientInvoiceData(this.model.id, this.model);
                }
                await UserService.getAccountErrors();
                this.closeModal();
            }
            catch (e) {
                console.log(e);
            }
            finally {
                this.isSaving = false;
                this.$store.commit("hideLoader");
            }
        },
        async fetchGusData(nip, destination) {
            try {
                this.$store.commit("showLoader");
                const response = await ClientInvoiceDataService.getGusData(nip);
                if (response.status === 200) {
                    if (destination === 'buyer') {
                        this.model.buyer.address = response.data.address;
                        this.model.buyer.city = response.data.city;
                        this.model.buyer.name = response.data.name;
                        this.model.buyer.postalCode = response.data.postalCode;
                        this.model.buyer.postOffice = response.data.postOffice;
                    } else {
                        this.model.recipient.address = response.data.address;
                        this.model.recipient.city = response.data.city;
                        this.model.recipient.name = response.data.name;
                        this.model.recipient.postalCode = response.data.postalCode;
                        this.model.recipient.postOffice = response.data.postOffice;
                    }
                }
            } catch (error) {
                console.error("Error fetching GUS data:", error);
            } finally {
                this.$store.commit("hideLoader");
            }
        },
        isRequiredMissing(value) {
            return (value || "").trim().length === 0;
        },
        isTooLong(value, maxLength) {
            return this.getLength(value) > maxLength;
        },
        getLength(value) {
            return (value || "").length;
        },
        isValidNipDigitsOnly
    }
}
</script>
<style lang="scss" scoped>
.client-invoice-data__group-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.client-invoice-data__group__button {
    border: 1px solid #bbc2ce;
    background-color: #ffffff;
    color: #00082c;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        background-color: #e8ebef;
    }
}

.edit-point-form__checkbox-top {
    display: flex;
    align-items: center;
    margin-top: 12px;
}

.edit-point-form__checkbox {
    width: 0px;
    height: 0px;
    display: none;

    &:checked~.edit-point-form__checkbox-mark {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.edit-point-form__checkbox-wrapper {
    width: 0px;
    height: 24px;
    position: relative;

    &:before {
        content: "";
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        width: 24px;
        height: 24px;
        position: relative;
        display: block;
        top: 0px;
        left: 0px;
        opacity: 1;
    }
}

.edit-point-form__checkbox-mark {
    background: #00082c;
    border: 1px solid #00082c;
    box-sizing: border-box;
    box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
    border-radius: 4px;
    width: 24px;
    height: 24px;
    position: absolute;
    z-index: 5;
    display: none;
    top: 0px;
    left: 0px;
    opacity: 1;
}

.edit-point-form__label {
    font-weight: 600;
    font-size: 14px;
    line-height: 145%;
    color: #00082c;

    &--checkbox {
        padding-left: 32px;
        z-index: 10;
        cursor: pointer;
        font-weight: normal !important;
    }
}

.input-has-error {
    border-color: red;
}

.esesja-modal__wraper__body__input:disabled {
    background-color: #f2f4f8;
    color: #8f95a3;
    cursor: not-allowed;
}



.client-invoice-modal {
    .button-show {
        width: 20%;
        height: 50px;
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        //box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        border-left: 0px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        //position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        &::after {
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            transform: translateY(-50%);
            height: 40px;
            width: 1px;
            background: #e2e5eb;
        }
    }

    .esesja-modal__row {
        margin-bottom: 0px;
    }

    .esesja-modal__wraper__body__input {
        margin-top: 0px;
    }
}
</style>
